<script>
import { Scatter, mixins } from 'vue-chartjs';
import zoom from 'chartjs-plugin-zoom';

const { reactiveProp } = mixins;

export default {
  extends: Scatter,
  mixins: [reactiveProp],
  name: 'ScatterChart',
  mounted() {
    this.addPlugin(zoom);
    this.renderChart(this.chartData, this.options);
  },
  props: {
    options: {
      type: Object,
    },
    reset: {
      type: Boolean,
      default: false,
    },
    autoRerender: {
      type: Boolean,
      default: true,
    },
    displayed: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    reset() {
      if (this.reset) {
        // eslint-disable-next-line
        this.$data._chart.resetZoom();
        this.$emit('unzoomed');
      }
    },
    options() {
      if (this.autoRerender || this.displayed) {
        this.renderChart(this.chartData, this.options);
      }
    },
    displayed(newVal, oldVal) {
      if (newVal && !oldVal) {
        setTimeout(() => {
          this.renderChart(this.chartData, this.options);
        }, 100);
      }
    },
  },
};
</script>
